import { useLang } from "@/contexts/LangContext";
import SectionReveal from "@/components/SectionReveal";

const HERO_LANTERNS =
  "https://images.unsplash.com/photo-1500754088824-ce0582cfe45f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxjaGluZXNlJTIwbGFudGVybiUyMGZlc3RpdmFsJTIwbmlnaHR8ZW58MHx8fHwxNzgwNDc5NDM1fDA&ixlib=rb-4.1.0&q=85";

const Festivals = () => {
  const { t } = useLang();

  return (
    <section
      id="festivals"
      data-testid="festivals-section"
      className="relative bg-[#0A0A0A] text-[#F7F5F0] py-24 md:py-32 overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{ backgroundImage: `url(${HERO_LANTERNS})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <SectionReveal className="max-w-3xl">
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#D4AF37] font-semibold mb-4">
            ✦ {t.festivals.eyebrow}
          </p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            {t.festivals.title}
          </h2>
        </SectionReveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {t.festivals.items.map((f, i) => (
            <SectionReveal
              key={f.name}
              delay={i * 0.1}
              data-testid={`festival-card-${i}`}
              className="border border-white/10 p-7 md:p-8 hover:border-[#D4AF37]/60 transition-colors duration-500 bg-white/[0.02] backdrop-blur-sm"
            >
              <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-3">
                {f.when}
              </p>
              <h3 className="font-heading text-2xl md:text-3xl">{f.name}</h3>
              <p className="mt-4 text-white/70 leading-relaxed">{f.body}</p>
            </SectionReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Festivals;
